import { createAsyncThunk } from "@reduxjs/toolkit";
import { qrLoginSlice } from "./qrLogin.slice";
import axios from "axios";

const reducerActions = qrLoginSlice.actions;

let config = {
	headers: {
	  "Content-Type": "application/json",
	  'Access-Control-Allow-Origin': '*',
	  "Access-Control-Allow-Headers": "*",
	  "Access-Control-Allow-Credentials": true,
	}
};

export enum QrLoginAction {
    FETCH_LOGIN_TOKEN = "qrLogin/getchLoginToken",
    POLL_LOGIN = "qrLogin/pollLogin",
}

export const fetchLoginToken = createAsyncThunk(
    QrLoginAction.FETCH_LOGIN_TOKEN,
    async (_, thunkAPI) => {
        const response = await axios.get("api/auth/qr-login-token", config).then(res => res.data);
        thunkAPI.dispatch(qrLoginActions.setLoginRequestToken(response))
    }
);

export const pollLoginOperation = createAsyncThunk(
    QrLoginAction.POLL_LOGIN,
    async (operationUid: string, thunkAPI) => {
        const response = await axios.get(`api/operations/${operationUid}`, config).then(res => res.data);
        thunkAPI.dispatch(qrLoginActions.setLoginOperation(response))
    }
)

export const qrLoginActions = {
    fetchLoginToken,
    pollLoginOperation,
    ...reducerActions,
}